import React, { useState } from 'react'
import "./../styles/colorbook.css";
import templates from '../flagdata';
import { Link, useParams } from 'react-router-dom';
import GameNav from '../GameNav';


const ColoringOptions = () => {

    const [selectedTemplate, setSelectedTemplate] = useState(1);

    const changeTemplateClick = (id) => {
        setSelectedTemplate(id)
    }








    return (
        <div id='color-options'>

            <GameNav />

            <div id='color-option-header'>

            </div>


            <section id='coloring-options-grid'>

                <div id="temps">
                    {templates.map((template, index) => (
                        <div className='cb-grid-img' key={index}
                            onClick={() => changeTemplateClick(template.id)}
                        >
                            <img src={template.slideImage} alt="Template Slide" />
                        </div>
                    ))}
                </div>


                <div id='temp-large-view'>

                    {templates.map((template) => {
                        if (template.id === selectedTemplate) {
                            return (
                                <div id='img-cont-cb' key={template.id}>
                                    <img className={`large-image-view ${template.id === 5 || template.id === 4 ? 'full-img-hat' : ''}`} src={`${process.env.PUBLIC_URL}${template.slideImage}`} />

                                </div>
                            )
                        }
                    })}

                    <Link className='chs-tmplt' to={`/coloringbook/${selectedTemplate}`} state={{ selectedTemplate }} style={{ textDecoration: 'none' }}>
                        <button className='choose-template-btn gold-gradient-wshimmer'>Start Drawing</button>
                    </Link>

                </div>

            </section>

        </div>
    )
}

export default ColoringOptions

